import { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Avatar,
  Rating,
  IconButton,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

const testimonials = [
  {
    name: "Sarah Nakato",
    role: "Homeowner",
    rating: 5,
    text: "Blossom Cleaning transformed our home after renovation. Their post-construction cleaning service was thorough and professional. Highly recommend!",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
  },
  {
    name: "James Okello",
    role: "Business Owner",
    rating: 5,
    text: "We use Blossom for our office deep cleaning monthly. The team is always punctual, professional, and leaves our space spotless. Excellent service!",
    avatar:
      "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop&crop=face",
  },
  {
    name: "Grace Nambi",
    role: "Property Manager",
    rating: 5,
    text: "Their fumigation service is top-notch. We manage multiple properties and Blossom has become our go-to for all cleaning and pest control needs.",
    avatar:
      "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=400&h=400&fit=crop&crop=fa",
  },
  {
    name: "David Musoke",
    role: "Homeowner",
    rating: 5,
    text: "The maid they provided is wonderful! Professional, trustworthy, and does an amazing job. Thank you Blossom for the excellent vetting process.",
    avatar:
      "https://unsplash.com/photos/a-woman-with-an-afro-standing-in-front-of-a-brick-wall-dsOHl-huCn0",
  },
];

const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const next = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prev = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  return (
    <Box sx={{ py: 8, backgroundColor: "background.default" }}>
      <Container>
        <Typography variant="h2" align="center" sx={{ mb: 2, fontWeight: 700 }}>
          What Our Clients Say
        </Typography>
        <Typography
          variant="h6"
          align="center"
          color="text.secondary"
          sx={{ mb: 6 }}
        >
          Trusted by hundreds of satisfied customers across Kampala
        </Typography>

        <Box sx={{ position: "relative", maxWidth: 800, mx: "auto" }}>
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
            >
              <Card
                sx={{
                  p: 4,
                  backgroundColor: "white",
                  boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                }}
              >
                <CardContent>
                  <FormatQuoteIcon
                    sx={{ fontSize: 48, color: "primary.main", mb: 2 }}
                  />
                  <Typography
                    variant="body1"
                    sx={{ mb: 3, fontSize: "1.1rem", lineHeight: 1.8 }}
                  >
                    "{testimonials[currentIndex].text}"
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Avatar
                      src={testimonials[currentIndex].avatar}
                      alt={testimonials[currentIndex].name}
                      sx={{ width: 60, height: 60 }}
                    />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {testimonials[currentIndex].name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {testimonials[currentIndex].role}
                      </Typography>
                      <Rating
                        value={testimonials[currentIndex].rating}
                        readOnly
                        size="small"
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </motion.div>
          </AnimatePresence>

          <Box
            sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4 }}
          >
            <IconButton
              onClick={prev}
              sx={{
                backgroundColor: "primary.main",
                color: "white",
                "&:hover": { backgroundColor: "primary.dark" },
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <IconButton
              onClick={next}
              sx={{
                backgroundColor: "primary.main",
                color: "white",
                "&:hover": { backgroundColor: "primary.dark" },
              }}
            >
              <ArrowForwardIcon />
            </IconButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default TestimonialCarousel;
